// 로그인 후 복귀 경로를 URL(returnUrl 쿼리) 대신 sessionStorage 로 보관.
// - 401/세션만료로 /login 으로 보낼 때 저장 → 로그인 성공 후 그 경로로 복귀.
// - URL 에 노출 안 됨(주소창 깨끗). 탭 단위 유지(sessionStorage), 하드 리다이렉트/새로고침에도 생존.

const KEY = "postLoginRedirect";

// 저장 제외 경로(로그인/공개/인증 경로 — 복귀 루프 방지)
const EXCLUDE = [
  "/login",
  "/launch",
  "/forgot-password",
  "/reset-password",
  "/account-link",
  "/signup",
];

// 내부 경로만 허용(open-redirect 방지): "/"로 시작 + "//" 아님.
function isInternal(p) {
  return typeof p === "string" && p.startsWith("/") && !p.startsWith("//");
}

// 복귀 경로 저장. 내부 경로가 아니거나 제외 경로면 무시.
export function saveRedirect(fullPath) {
  try {
    if (!isInternal(fullPath)) return;
    if (
      EXCLUDE.some(
        (e) =>
          fullPath === e ||
          fullPath.startsWith(e + "/") ||
          fullPath.startsWith(e + "?"),
      )
    )
      return;
    sessionStorage.setItem(KEY, fullPath);
  } catch (e) {
    /* storage 사용 불가(사생활 모드 등) 무시 */
  }
}

// 저장된 복귀 경로를 꺼내고 제거(1회성). 없거나 부적합하면 null.
export function takeRedirect() {
  try {
    const v = sessionStorage.getItem(KEY);
    sessionStorage.removeItem(KEY);
    return isInternal(v) ? v : null;
  } catch (e) {
    return null;
  }
}
